import { render } from "./deleted.widget.wp.vue?vue&type=template&id=3720ab49"
import script from "./deleted.widget.wp.vue?vue&type=script&lang=js"
export * from "./deleted.widget.wp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__